export default __webpack_public_path__ + "static/210602_夏日活動強更預告_kr-f9513b57cc427494ee82968941f0a20d.webp";